import _defineProperty from "D:\\a\\1\\s\\fepu\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var genLayoutLightStyle = function genLayoutLightStyle(token) {
  var componentCls = token.componentCls,
    bodyBg = token.bodyBg,
    lightSiderBg = token.lightSiderBg,
    lightTriggerBg = token.lightTriggerBg,
    lightTriggerColor = token.lightTriggerColor;
  return _defineProperty({}, "".concat(componentCls, "-sider-light"), _defineProperty(_defineProperty({
    background: lightSiderBg
  }, "".concat(componentCls, "-sider-trigger"), {
    color: lightTriggerColor,
    background: lightTriggerBg
  }), "".concat(componentCls, "-sider-zero-width-trigger"), {
    color: lightTriggerColor,
    background: lightTriggerBg,
    border: "1px solid ".concat(bodyBg),
    // Safe to modify to any other color
    borderInlineStart: 0
  }));
};
export default genLayoutLightStyle;